/* Scoped adapters. No Jackery cart, tracking, account or review scripts. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.hp2AdapterReady) return;
    root.dataset.hp2AdapterReady = 'true';
    const official = root.querySelector('[data-hp2-official]');
    if (!official) return;
    official.querySelectorAll('.blocks-tabs-blocks').forEach((block, group) => {
      const list = block.querySelector('.tabs-nav-ul');
      const items = [...block.querySelectorAll('.blocks-tab-item')];
      if (!list || !items.length) return;
      list.replaceChildren();
      const buttons = items.map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.role = 'tab';
        button.textContent = item.querySelector('.tab-nav')?.textContent.trim() || `View ${index + 1}`;
        const panel = item.querySelector('[role=tabpanel]') || item;
        panel.id = `${root.id}-tab-${group}-${index}`;
        button.setAttribute('aria-controls', panel.id);
        const li = document.createElement('li');li.append(button);list.append(li);
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
          activate(next);buttons[next].focus();
        });
        return button;
      });
      function activate(index) {
        items.forEach((item, i) => {item.hidden = i !== index;item.classList.remove('invisible');});
        buttons.forEach((button, i) => {button.setAttribute('aria-selected', String(i === index));button.tabIndex = i === index ? 0 : -1;});
      }
      activate(0);
    });
    const runtime = official.querySelector('[data-hp2-runtime]');
    if (runtime) {
      const capacity = runtime.querySelector('select'), watts = runtime.querySelector('input'), output = runtime.querySelector('output');
      function calculate() {
        const load = Number(watts.value);
        output.textContent = load > 0 && load <= 2400 ? `${(Number(capacity.value) * .85 / load).toFixed(1)} hours` : 'Enter 1–2,400W';
      }
      runtime.addEventListener('input', calculate);calculate();
    }
    const equipment = {
      basic: ['HomePower 2000 Plus v2 × 1'],
      battery: ['HomePower 2000 Plus v2 × 1', 'Battery Pack 2000 Plus v2 × 1'],
      solar500: ['HomePower 2000 Plus v2 × 1', 'SolarSaga 500W solar panel × 1'],
      solar200: ['HomePower 2000 Plus v2 × 1', 'SolarSaga 200W solar panel × 2']
    };
    function box(key, title) {
      const list = official.querySelector('[data-hp2-box-items]');
      if (!list) return;
      official.querySelector('[data-hp2-box-name]').textContent = title || 'HomePower 2000 Plus v2';
      list.replaceChildren(...(equipment[key] || equipment.basic).map(text => {const li = document.createElement('li');li.textContent = text;return li;}));
    }
    root.addEventListener('hp2:variant', e => box(e.detail.box, e.detail.title));
    const selected = root.querySelector('[data-hp2-variant].is-selected');
    box(selected?.dataset.box || 'basic', selected?.textContent.trim());
    official.querySelectorAll('[data-hp2-youtube]').forEach(button => button.addEventListener('click', () => {
      const frame = document.createElement('iframe');
      frame.className = 'hp2-video-frame';frame.title = 'Official Jackery how-to video';
      frame.src = `https://www.youtube-nocookie.com/embed/${button.dataset.hp2Youtube}?autoplay=1`;
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen = true;
      const player = document.createElement('div');player.className = 'hp2-youtube-player';player.append(frame);
      const link = document.createElement('a');link.className = 'hp2-youtube-link';link.href = `https://www.youtube.com/watch?v=${button.dataset.hp2Youtube}`;link.target = '_blank';link.rel = 'noopener';link.textContent = 'Video not playing? Watch on YouTube ↗';
      button.replaceWith(player);player.after(link);
    }));
    official.querySelectorAll('jds-button[label="Watch Video"]').forEach(custom => {
      const button = document.createElement('button');button.type = 'button';button.className = 'hp2-watch-video';button.textContent = '▶ Watch Video';custom.replaceWith(button);
      button.addEventListener('click', () => {
        const dialog = document.createElement('dialog');dialog.className = 'hp2-video-dialog';
        const close = document.createElement('button');close.type = 'button';close.textContent = 'Close ×';
        const frame = document.createElement('iframe');frame.title = 'Jackery HomePower 2000 Plus v2 product video';frame.src = 'https://www.youtube-nocookie.com/embed/8CNzZ1D7_r8?autoplay=1';frame.allow = 'autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen = true;
        close.addEventListener('click', () => dialog.close());dialog.addEventListener('close', () => dialog.remove());
        dialog.append(close, frame);document.body.append(dialog);dialog.showModal();close.focus();
      });
    });
    official.querySelectorAll('video:not([data-hp2-route-video])').forEach(video => {
      video.muted = true;video.loop = true;video.controls = true;
      new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && video.getClientRects().length && !matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
        else video.pause();
      }, {rootMargin: '0px'}).observe(video);
    });
    official.querySelectorAll('.accordion-title,.accordion-header').forEach(button => {
      const content = button.nextElementSibling;
      if (!content) return;
      button.setAttribute('role', 'button');button.tabIndex = 0;button.setAttribute('aria-expanded', 'true');
      content.style.display = 'block';content.style.height = 'auto';content.style.maxHeight = 'none';
      const toggle = () => {content.hidden = !content.hidden;button.setAttribute('aria-expanded', String(!content.hidden));};
      button.addEventListener('click', toggle);
      button.addEventListener('keydown', e => {if (['Enter', ' '].includes(e.key)) {e.preventDefault();toggle();}});
    });
    // Independent covers remain visible until a selected video is genuinely playing.
    // No dependency on global hidden/lg:block utilities or the source site's scroll runtime.
    official.querySelectorAll('[data-hp2-routing]').forEach(scene => {
      const panels = [...scene.querySelectorAll('[data-hp2-stage]')];
      const buttons = [...scene.querySelectorAll('[data-hp2-route-tab]')];
      const caption = scene.querySelector('[data-hp2-stage-caption]');
      const status = scene.querySelector('[data-hp2-route-status]');
      const mobile = matchMedia('(max-width:1023.98px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0, inView = false;
      function play(panel, requested = false) {
        const video = panel.querySelector('video');
        if (!video || panel.hidden || (!requested && (reduced.matches || video.dataset.failed))) return;
        const source = mobile.matches ? video.dataset.srcMobile : video.dataset.srcPc;
        const image = panel.querySelector('picture img');
        video.poster = image.currentSrc || image.src;
        if (video.getAttribute('src') !== source) {video.src = source;video.preload = 'metadata';video.load();}
        if (requested) {delete video.dataset.failed;status.textContent = '';}
        video.play().catch(error => {
          panel.classList.remove('is-playing');
          if (!panel.hidden && error.name !== 'AbortError') status.textContent = error.name === 'NotAllowedError' ? 'Select Play video to start.' : 'Video unavailable. The product image remains visible; you can try Play video again.';
        });
      }
      panels.forEach((panel, index) => {
        const video = panel.querySelector('video');if (!video) return;
        video.addEventListener('playing', () => {if (!panel.hidden) {panel.classList.add('is-playing');status.textContent = '';}});
        video.addEventListener('pause', () => panel.classList.remove('is-playing'));
        video.addEventListener('error', () => {video.dataset.failed = 'true';panel.classList.remove('is-playing');if (!panel.hidden) status.textContent = 'Video unavailable. The product image remains visible; you can try Play video again.';});
        panel.querySelector('[data-hp2-route-play]').addEventListener('click', () => play(panel, true));
        panel.id = `${root.id}-routing-${index}`;
      });
      function activate(index, requested = false) {
        active = index;status.textContent = '';caption.textContent = panels[index].dataset.caption;
        panels.forEach((panel, i) => {panel.hidden = i !== index;if (i !== index) {panel.querySelector('video')?.pause();panel.classList.remove('is-playing');}});
        buttons.forEach((button, i) => {button.setAttribute('aria-selected', String(i === index));button.tabIndex = i === index ? 0 : -1;});
        if (inView || requested) play(panels[index], requested);
      }
      buttons.forEach((button, index) => {
        if (!panels[index].id) panels[index].id = `${root.id}-routing-${index}`;
        button.setAttribute('aria-controls', panels[index].id);panels[index].setAttribute('role', 'tabpanel');
        button.addEventListener('click', () => activate(index, true));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          activate(next, true);buttons[next].focus();
        });
      });
      new IntersectionObserver(entries => {inView = entries[0].isIntersecting;if (inView) play(panels[active]);else panels.forEach(panel => panel.querySelector('video')?.pause());}, {rootMargin:'0px'}).observe(scene);
      mobile.addEventListener('change', () => {if (inView) play(panels[active]);});
      activate(0);
    });
    root.querySelectorAll('[data-hp2-mode]').forEach(button => button.addEventListener('click', () => {
      const model = button.dataset.hp2Mode === 'model';
      if (model && location.protocol === 'file:') {
        let note = root.querySelector('[data-hp2-model-note]');
        if (!note) {note = document.createElement('p');note.dataset.hp2ModelNote = '';note.role = 'status';root.querySelector('.hp2-gallery__modes').after(note);}
        note.textContent = '3D requires an HTTP preview or the Shopify product page. Photos are available in this local file preview.';
        return;
      }
      root.querySelector('[data-hp2-model]').hidden = !model;
      root.querySelector('[data-hp2-zoom]').hidden = model;
      root.querySelectorAll('[data-hp2-mode]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      if (model && !customElements.get('model-viewer') && !document.querySelector('[data-hp2-model-library]')) {
        const script = document.createElement('script');script.src = button.dataset.modelScript;script.dataset.hp2ModelLibrary = 'true';document.head.append(script);
      }
    }));
  }
  const boot = scope => scope.querySelectorAll('[data-hp2-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
